import { renderTick } from '~/legacy/runtime'
import type { Row } from '~/composables/useDb'

/** `createSecondSemestre` de la maquette : crée le 2e semestre d'une année qui n'a que le 1er. */
export async function createSecondSemestre(anneeId: number): Promise<void> {
  const db = useDb()
  const periodes = db.value.periodes ?? []
  const annee = findById('annees', anneeId)
  const s1 = periodes.find(p => p.anneeId === anneeId && Number(p.ordre) === 1)
  if (!annee || !s1) {
    showToast('Impossible de créer le 2e Semestre : le 1er Semestre est introuvable.')
    return
  }
  if (periodes.some(p => p.anneeId === anneeId && Number(p.ordre) === 2)) {
    showToast('Le 2e Semestre existe déjà.')
    return
  }
  const debut = new Date(String(s1.dateFin))
  debut.setDate(debut.getDate() + 1)
  const body = { libelle: '2e Semestre', type: s1.type || 'SEMESTRE', ordre: 2, anneeId, dateDebut: debut.toISOString().slice(0, 10), dateFin: annee.dateFin }
  try {
    const saved = await $fetch<Row>('/api/periodes', { method: 'POST', body })
    db.value = { ...db.value, periodes: [...periodes, saved] }
    showToast(`2e Semestre créé pour ${annee.libelle}.`)
    renderTick.value++
  }
  catch (e) {
    console.error('[Registre] useSemestre:', e)
    showToast('Opération impossible.')
  }
}
